import React from 'react';
import { GraduationCap, MapPin, Calendar } from 'lucide-react';

const Education = ({ data, language, translations }) => {
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || {};
  
  // Get translated education data
  const educationData = t.educationData || profileData.education;

  return (
    <div className="content-section">
      <h2 className="section-title">{t.education || 'Educación'}</h2>
      <div className="section-content">
        {educationData.map((edu, index) => (
          <div key={edu.id || index} className="education-card">
            <div className="card-header">
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <GraduationCap size={20} color="var(--steel-dim)" />
                  <h3 className="card-title">{edu.degree}</h3>
                </div>
                <p className="card-subtitle">{edu.institution}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <MapPin size={16} color="var(--text-secondary)" />
                    <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{edu.location}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Calendar size={16} color="var(--text-secondary)" />
                    <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{edu.period}</span>
                  </div>
                </div>
              </div>
              <div style={{ 
                background: edu.status === 'En curso' || edu.status === 'Ongoing' ? 'rgba(176, 107, 255, 0.2)' : 'rgba(40, 202, 66, 0.2)', 
                color: 'var(--cyan-primary)', 
                padding: '4px 12px', 
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '600',
                border: '1px solid var(--cyan-primary)'
              }}>
                {edu.status}
              </div>
            </div>

            {edu.description && (
              <p className="card-description">{edu.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
